import { gql } from 'apollo-boost';

export const CREATE_CART = gql`
  mutation doCreateCart($data: CartInput!) {
    createCart(data: $data) {
      id
      updatedAt
      createdAt
      region
      status
      clientId
    }
  }
`;
